import { writable } from "svelte/store";

function getLocalStorageData(key) {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : undefined;
}

function writeLocalStorageData(key, data) {
  localStorage.setItem(key, JSON.stringify(data))
}

function removeLocalStorageData(key) {
  localStorage.removeItem(key)
}

export const createPersistedStore = key => {
  const { subscribe, set } = writable(getLocalStorageData(key));
  
  return {
    subscribe,
    set: data => {
      if (data == null) {
        removeLocalStorageData(key)
      } else {
        writeLocalStorageData(key, data)
      }
      set(data);
    }
  };
}